import { useEffect, useState } from "react";

import AppRouter from "./AppRouter";

// Styles
import * as Sentry from "@sentry/react";
import "./styles/App.scss";

import { BrowserTracing } from "@sentry/tracing";
import { GC } from "./services/config/gamecentreService";
import { NEW_DATA_EVENT } from "./constants/const";
import { storage } from "./services/config/storage";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});

function App() {
  const [gameDetails, setGameDetails] = useState(null);
  const gameInIframe = window.location !== window.parent.location;

  const syncData = () => {
    const getGameDetails = storage.get.gameDetails();
    setGameDetails(getGameDetails);
  };

  const handleBlur = () => {
    GC.sendGameBlurredMessage()
  }

  useEffect(() => {
    const element = document.querySelector(".app-container");

    element.addEventListener("touchstart", (e) => {
      // is not near edge of view, exit
      if (e.pageX > 20 && e.pageX < window.innerWidth - 20) {
        console.log("lol");
        return;
      }

      // prevent swipe to navigate back gesture
      // e.preventDefault();
    });

    if (!gameInIframe) {
      // Not calling gamecenter apis if not loaded in it.
      return;
    }

    // Send mount/load event to assessment centre to get token and gameplayId (linkId)
    GC.sendGameLoadMessage();

    window.addEventListener("message", GC.messageEventHandler);
    window.addEventListener(NEW_DATA_EVENT, syncData);
    window.addEventListener("blur", handleBlur)

    return () => {
      window.addEventListener("message", GC.messageEventHandler);
      window.removeEventListener(NEW_DATA_EVENT, syncData);
      window.removeEventListener("blur", handleBlur)
    };
  }, []);

  /**
   *  Render game if any two conditions met
   *  @param {boolean} gameInIframe - Check game window loaded in iframe to call/not call GC/SDK apis
   *  @param {object} gameDetails - (When game loaded in iframe) Make GC/SDK apis call and set gameData/gameDetails,
   *  which dispatch a window NEW_DATA_EVENT, which sets gameDetails { orgName, mediaUrl, gameName }
   */
  return (
    <Sentry.ErrorBoundary
      onError={(err) => console.log(err)}
      fallback={<p>An error has occurred</p>}
    >
      <div className="app-container">
        {(!gameInIframe || gameDetails) && <AppRouter />}
      </div>
    </Sentry.ErrorBoundary>
  );
}

export default App;
